import _ from "lodash";

export const isClearformVaild = (secArr, index) => {
  let sections = _.cloneDeep(secArr);
  for (let i = 0; i < sections.length; i++) {
    for (let j = 0; j < sections[i].fields.length; j++) {
      if (sections[i].fields[j].type === 'String') {
        if (sections[i].fields[j].name !== 'Email ID' && sections[i].fields[j].name !== 'Mobile Number') {
          sections[i].fields[j].answer = '';
        }

      }

      if (sections[i].fields[j].type === 'File') {
        sections[i].fields[j].files[0] = "";
      }

      if (sections[i].fields[j].type === 'Dropdown') {
        sections[i].fields[j].optionId = "null";
      }

      if (sections[i].fields[j].type === "MultiField") {
        if (sections[i].fields[j].isConditional === true) {
          let filetConditionalData = sections[i].fields[j].child.filter(ele => ele.isDeciding === true);
          let filterConditionalAnsData = sections[i].fields[j].child.filter(ele => ele.refOptionId === filetConditionalData[0].optionId);

          if (filetConditionalData) {
            if (index !== 1 || (filetConditionalData[0].name !== 'Pan Card No.' && filetConditionalData[0].name !== 'GSTIN No.')) {
              filetConditionalData[0].optionId = "null";
            }

            for (let i = 0; i < filterConditionalAnsData.length; i++) {
              if (filterConditionalAnsData[i]?.type === "String") {
                if (index !== 1 || (filterConditionalAnsData[i].uniqueName !== 'PAN_NO' && filterConditionalAnsData[i].uniqueName !== 'GSTIN')) {
                  filterConditionalAnsData[i].childAnswer = '';
                }
              }
              if (filterConditionalAnsData[i]?.type === "Dropdown") {
                filterConditionalAnsData[i].optionId = "null";
              }
              if (filterConditionalAnsData[i]?.type === "File") {
                filterConditionalAnsData[i].files = '';

              }
            }
          }

        }
        else {
          for (let k = 0; k < sections[i].fields[j].child.length; k++) {
            let childData = sections[i].fields[j].child[k];
            if (childData?.type === "String") {
              childData.childAnswer = '';
            }
            if (childData?.type === "File") {
              childData.files = '';

            }
            if (childData?.type === "Dropdown") {
              sections[i].fields[j].optionId = "null";

            }
            if (childData?.type === "Object") {
              childData.childAnswer = '';
            }
          }
        }
      }
    }
  }
  return sections;
};